<template>
  <div
    v-if="visible"
    :style="{ zIndex: zIndex }"
    class="overlay"
    @click.prevent="closeOverlay"
  ></div>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      required: true,
    },
    zIndex: {
      type: Number,
      default: 105,
    },
  },
  methods: {
    closeOverlay() {
      this.$emit('close')
    },
  },
}
</script>

<style scoped>
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.2);
}
</style>
